import '@tensorflow/tfjs-core';
import '@tensorflow/tfjs-backend-webgl';
import * as handPoseDetection from '@tensorflow-models/hand-pose-detection';
// import * as hands from '@mediapipe/hands';
import { DpcThumbsUp } from './gesture';
import * as fp from '../vendor/fingerpose/fingerpose';
import { assetPath } from './path';
let detector;

async function aFind(items, cb) {
  for (const [index, element] of items.entries()) {
    if (await cb(element, index, items)) {
      return element;
    }
  }

  return undefined;
}

export const getHandpose = async () => {
  if (detector) return detector;
  const model = handPoseDetection.SupportedModels.MediaPipeHands;
  const detectorConfig = {
    runtime: 'tfjs',
    detectorModelUrl: `${assetPath}virtual-photo-booth/models/handpose-3d-tfjs-detector-full-v1/model.json`,
    landmarkModelUrl: `${assetPath}virtual-photo-booth/models/handpose-3d-tfjs-landmark-full-v1/model.json`,
  };
  detector = await handPoseDetection.createDetector(model, detectorConfig);

  return detector;
};

export const gestureEstimator = new fp.GestureEstimator([DpcThumbsUp]);

const maxInputSize = (() => {
  const canvas = document.createElement('canvas');
  const gl = canvas.getContext('webgl');
  if (!gl) return 1024; // estimate a safe fallback, allthough the code will crash without webgl support
  return gl.getParameter(gl.MAX_TEXTURE_SIZE) / 4;
})();

export const estimate = async (
  inputElement,
  handposeModel,
  gestureEstimator
) => {
  let manageableScale = 1;

  if (inputElement.width > maxInputSize || inputElement.height > maxInputSize) {
    manageableScale = Math.min(
      maxInputSize / inputElement.width,
      maxInputSize / inputElement.height
    );

    const scaledWidth = inputElement.width * manageableScale;
    const scaledHeight = inputElement.height * manageableScale;

    const scaledCanvas = document.createElement('canvas');
    scaledCanvas.width = scaledWidth;
    scaledCanvas.height = scaledHeight;

    const scaledContext = scaledCanvas.getContext('2d');
    if (!scaledContext) return null;
    scaledContext.drawImage(inputElement, 0, 0, scaledWidth, scaledHeight);
    inputElement = scaledCanvas;
  }

  const predictions = await handposeModel.estimateHands(inputElement, {
    staticImageMode: true,
  });

  if (predictions.length === 0) return null;

  const hand = await aFind(predictions, async prediction => {
    const result = await gestureEstimator.estimate(prediction.keypoints3D, 8.5);
    return result.gestures.length > 0;
  });

  if (!hand) return null;

  const correctionScale = 1 / manageableScale;

  const originalKeypoints = hand.keypoints.map(p => ({
    x: p.x * correctionScale,
    y: p.y * correctionScale,
  }));

  const boundingBox = {
    top: Math.min(...originalKeypoints.map(p => p.y)),
    left: Math.min(...originalKeypoints.map(p => p.x)),
    bottom: Math.max(...originalKeypoints.map(p => p.y)),
    right: Math.max(...originalKeypoints.map(p => p.x)),
  };

  return { hand, boundingBox };
};
